import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AppModal from "components/ui/AppModal/AppModal";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(true);
  }, [navigate]);

  const handleDone = () => {
    setOpen(false);
    navigate("/plans");
  };

  return (
    <AppModal
      isOpen={open}
      onClose={handleDone}
      allowOutsideClick={false}
      variant="success"
      title="Pagamento realizado com sucesso!"
      message={null}
      confirmText="OK"
      cancelText={null}
      onConfirm={handleDone}
      onCancel={handleDone}
    />
  );
};

export default PaymentSuccess;
